
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.614 23.401L2.575 11.351a1.96 1.96 0 112.772-2.775l10.656 10.66 10.65-10.66a1.955 1.955 0 012.772 0 1.96 1.96 0 010 2.774l-12.04 12.051c-.38.381-.884.572-1.382.572-.504 0-1.008-.19-1.389-.572z"}})])
          )
        }
      }
    